module.exports = __webpack_public_path__ + "img/zoom2.2c24d1d3.svg";